import React from 'react'
import styled from '@emotion/styled'

import { convertToReadableDate, sortMethods } from 'Helpers'

import Section from 'Components/Section'
import GridRow from 'Components/Grid/GridRow'
import Report from 'Components/Report'

const GridRowAlert = styled(GridRow)`
  &:nth-of-type(2n) > * {
    ${({ critical }) => critical && 'background: #e01b1b;'}
    ${({ warning }) => warning && 'background: #444;'}
  }
  &:nth-of-type(2n + 1) > * {
    ${({ critical }) => critical && 'background: #c21717;'}
    ${({ warning }) => warning && 'background: #333;'}
  }
`

const AlertRow = ({ row: alert }) => (
  <>
    <GridRowAlert>
      <div>{alert.patientRef}</div>
      <div>{alert.physician}</div>
      <div>{alert.tCode}</div>
      <div>{alert.responses}</div>
      <div>{alert.bpCuffCount}</div>
      <div>{alert.nonBpCuffCount}</div>
      <div>{alert.confirmedReceipt}</div>
      <div>{alert.trainedByDoctor}</div>
    </GridRowAlert>
  </>
)

const columns = [
  { header: 'Patient', property: 'patientRef' },
  { header: 'Physician', property: 'physician' },
  { header: 'T-Code', property: 'tCode' },
  { header: 'Responses', property: 'responses', sort: sortMethods.number },
  { header: 'BT Cuff', property: 'bpCuffCount' },
  { header: 'Non-BT Cuff', property: 'nonBpCuffCount' },
  { header: 'Confirmed Receipt', property: 'confirmedReceipt' },
  { header: 'Trained By Doctor', property: 'trainedByDoctor' }
]

export default ({ report }) => {
  const reportByJourney = report.journeys.reduce((acc, item) => {
    if (acc[item.journeyId] == undefined) {
      acc[item.journeyId] = []
    }

    acc[item.journeyId].push(item)
    return acc
  }, {})

  return (
    <>
      {Object.keys(reportByJourney).map(journeyId => {
        const journeyReport = reportByJourney[journeyId]
        return (
          <>
            <Section header="Journey" title={journeyReport[0].journey} />
            <Report
              id="device"
              report={{ deviceReport: journeyReport }}
              columns={columns}
              ReportRow={AlertRow}
              defaultSortIndex={0}
              prop="deviceReport"
            />
          </>
        )
      })}
    </>
  )
}
